import React, { useEffect, useRef, useState } from "react";
import "./AIFeedbackPerformance.css";


  // Messages to display
 const defaultMessages = [
    "Thinking",
    "Searching your data",
    "Double-checking everything",
    "Analyzing the patterns",
    "Organizing the information",
     "Preparing your insights",
    "Getting everything ready",
    "Just a moment, we're almost done"
  ];
const LoadingMessages = ({ messages }) => {

const messagesToDisplay = messages && messages.length > 0 ? messages : defaultMessages;
    
const [currentMessage, setCurrentMessage] = useState('');
  const messageIndexRef = useRef(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    messageIndexRef.current = 0; // Reset index

    const displayNextMessage = () => {
      setCurrentMessage(messagesToDisplay[messageIndexRef.current]);

      messageIndexRef.current += 1;

      if (messageIndexRef.current < messagesToDisplay.length) {
        timeoutRef.current = setTimeout(displayNextMessage, 2500);
      }
    };

    displayNextMessage(); // Start cycling

  

    // Cleanup on unmount or dependency change
    return () => {
      clearTimeout(timeoutRef.current);
      setCurrentMessage('');
    };
  },[]);

  return(
       <p className="loading-text">
         {currentMessage}
         <span class="loader__dot">.</span><span class="loader__dot">.</span><span class="loader__dot">.</span>
     </p>
  )
}

export default LoadingMessages;